export type BuildPaymentPlan = {
  down: number
  monthly: number
  total: number
}

/**
 * Splits a one-time implementation fee evenly across three
 * payments: one at signing, then one in each of months 2 and 3.
 *
 * Months 2 and 3 are rounded to the nearest $50 so the figures stay clean, and
 * any remainder lands on the payment at signing.
 */
export function getBuildPaymentPlan(total: number): BuildPaymentPlan {
  const monthly = Math.round(total / 3 / 50) * 50

  return {
    down: total - monthly * 2,
    monthly,
    total,
  }
}
